import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'bc-not-found',
  template: `
    <img
      src="/assets/images/error-404.png"
      alt="Not Found"
    />
    <div class="flex flex-column align-items-center gap-spacing-default">
      <h3 class="body-large-bold text-primary-color m-0">Error 404</h3>
      <p class="body-medium-regular text-caption-color m-0">
        Sorry, but the page you are looking for doesn't exist.
      </p>
    </div>
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: var(--spacing-3xl, 24px);
      padding: var(--px-200, 200px) 0 var(--spacing-3xl, 24px) 0;
      background: #ffffff;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class NotFoundComponent {}
